import { useEffect } from "react";
import { useAccount, useChainId, useSwitchChain } from "wagmi";
import { CHAINS } from "../config/contracts";

const ChainGuard = () => {
  const { isConnected } = useAccount();
  const chainId = useChainId();
  const { switchChain } = useSwitchChain();

  useEffect(() => {
    if (isConnected && chainId && chainId !== CHAINS.SEPOLIA) {
      // User is connected but on wrong chain, automatically request switch
      try {
        switchChain({ chainId: CHAINS.SEPOLIA });
      } catch (err) {
        console.error("Failed to switch chain:", err);
      }
    }
  }, [isConnected, chainId, switchChain]);

  return null; // This component doesn't render anything
};

export default ChainGuard;

